
import { REF_CODE_METADATA } from './ref-code.metadata';
import { RefCode, RefCodeKey } from './ref-code.model';
import { GenericEntityDecorator } from '@scisys-uim/uim-common';


export abstract class RefCodeEntityDecoratorBase extends GenericEntityDecorator<RefCode, RefCodeKey> {
  constructor() {
    super(REF_CODE_METADATA, {
    }, {
    });
  }
  toKeyObjectFromRouteParams(params: any): RefCodeKey {
    if (params == null || params.code == null || params.domain == null) {
      return null;
    }
    return {
      code: params.code,
      domain: params.domain
    };
  }
  toKeyUrlPathSegments(key: RefCodeKey): string {
    if (key?.code == null || key?.domain == null) {
      return null;
    }
    return key.code + '/' + key.domain;
  }
  toKeyRouteSegments(item: RefCode): any[] {
    const key: RefCodeKey = this.metadata?.toKeyObject(item);
    if (key == null) {
      return null;
    }
    return [key.code, key.domain];
  }
}




